import React from 'react';

import { AgeValues } from '~/components/Shared/Filters_DEPRECATED/Values/AgeValues';
import { BooleanTextValue } from '~/components/Shared/Filters_DEPRECATED/Values/BooleanTextValue';
import { BooleanValues } from '~/components/Shared/Filters_DEPRECATED/Values/BooleanValues';
import { DateValues } from '~/components/Shared/Filters_DEPRECATED/Values/DateValues';
import { EnumValues } from '~/components/Shared/Filters_DEPRECATED/Values/EnumValues';
import { FileValues } from '~/components/Shared/Filters_DEPRECATED/Values/FileValues';
import { NumberValues } from '~/components/Shared/Filters_DEPRECATED/Values/NumberValues';
import { Nullable } from '~/eds/src/types/Nullable';
import { Field } from '~/evifields/src/types/Field';
import { Filter } from '~/evifields/src/types/Filter';
import { FilterViewType } from '~/evifields/src/types/FilterView';
import {
  AsyncValue,
  ClauseValue,
  DateValue,
  NumberValue,
  TextValue,
  Value,
} from '~/evifields/src/types/Value';

import ClauseValues from './ClauseValues/ClauseValues';
import { EnumSetValues } from './EnumSetValues';
import { TextValues } from './TextValues';

interface Props {
  field: Field;
  filter: Filter;
  onChange: (
    updatedValues: Value[],
    updatedAsyncValue?: AsyncValue<Value>,
  ) => void;
  onViewChange?: (filterView: Nullable<FilterViewType>) => void;
}

const Values = ({ field, filter, onChange, onViewChange }: Props) => {
  switch (field.type) {
    case 'age':
      return (
        <AgeValues filter={filter as Filter<NumberValue>} onChange={onChange} />
      );
    case 'boolean':
      return <BooleanValues />;
    case 'clause':
      return (
        <ClauseValues
          field={field as Field<'clause_v2'>}
          filter={filter as Filter<ClauseValue>}
          onChange={onChange}
        />
      );
    case 'date':
      return (
        <DateValues filter={filter as Filter<DateValue>} onChange={onChange} />
      );
    case 'enum': {
      return (
        <EnumValues
          field={field as Field<'enum'>}
          filter={filter}
          onChange={onChange}
        />
      );
    }
    case 'enum_set':
    case 'folder': {
      return (
        <EnumSetValues
          field={field as Field<'enum_set'>}
          filter={filter}
          onChange={onChange}
          onViewChange={onViewChange}
        />
      );
    }
    case 'file':
      return <FileValues />;
    case 'number':
      return (
        <NumberValues
          filter={filter as Filter<NumberValue>}
          onChange={onChange}
        />
      );
    case 'text':
    case 'text_search':
      return (
        <TextValues
          field={field}
          filter={filter as Filter<TextValue>}
          onChange={onChange}
        />
      );
    case 'bool_text_search':
      return (
        <BooleanTextValue
          filter={filter as Filter<TextValue>}
          onChange={onChange}
        />
      );
    default:
      return null;
  }
};

export default Values;
